angular.module( 'acme.view.application.dashboard.admin', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.view.application.dashboard.admin.controllers',
  'acme.common.directive.lineGraph',
  'acme.common.directive.arcGraph'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var dashboardAdmin = {
        name: 'application.dashboardAdmin',
        url: '/dashboard/admin',
        views: {
          "subview-main": {
            controller: 'DashboardAdminController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/dashboard/admin/admin.tpl.html'
          }
        },
        resolve: {
          d3: ['$q', function($q) {

            var q = $q.defer();

            // Usage
            $.cachedScript( "/assets/d3.min.js" ).done(function( script, textStatus ) {
              q.resolve('done');
            });

            return q.promise;
          }],
          CompanyData: [ 'ApiService', 'AuthService', function(ApiService, AuthService) {
            return ApiService.tenant.view(AuthService.getCookie('user').tenantId);
          }]
        },
        data: {
          pageTitle: 'Dashboard',
          pageClass: 'application application-dashboard-admin',
          roles: ['superuser']
        }
      };

    $stateProvider
      .state(dashboardAdmin);
});
